import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mydocma-android-file-choice-dialog',
  templateUrl: './android-file-choice-dialog.component.html',
  styleUrls: ['./android-file-choice-dialog.component.css']
})
export class AndroidFileChoiceDialogComponent {

  constructor(private dialogRef: MatDialogRef<AndroidFileChoiceDialogComponent>) {}

  choose(option: 'camera' | 'file') {
    this.dialogRef.close(option);
  }

  close() {
    this.dialogRef.close(null);
  }
}
